module.exports = __webpack_public_path__ + "img/andorra.f30f22aa.png";